import { createRouter, createWebHashHistory } from "vue-router";
const routes = [
  {
    path: "/",
    component: () => import("@/views/home.vue"),
    redirect: "/home",
    children: [
      {
        meta: {
          title: "首页",
        },
        path: "/home",
        component: () => import("@/views/home_home.vue"),
      },
      {
        meta: {
          title: "核心技术",
        },
        path: "/core",
        component: () => import("@/views/home_core.vue"),
      },
      {
        meta: {
          title: "数据服务",
        },
        path: "/data",
        component: () => import("@/views/home_data.vue"),
      },
      {
        meta: {
          title: "产品介绍",
          pageName: "数据开发管理平台",
        },
        path: "/details/1",
        component: () => import("@/views/home_prod/dataDevelopment.vue"),
      },
      {
        meta: {
          title: "产品介绍",
          pageName: "语料开发管理平台",
        },
        path: "/details/2",
        component: () => import("@/views/home_prod/corpus.vue"),
      },
      {
        meta: {
          title: "产品介绍",
          pageName: "湖仓一体大数据平台",
        },
        path: "/details/3",
        component: () => import("@/views/home_prod/lakeWarehouse.vue"),
      },
      {
        meta: {
          title: "产品介绍",
          pageName: "AI智能问数助手",
        },
        path: "/details/4",
        component: () => import("@/views/home_prod/aiChart.vue"),
      },

      {
        meta: {
          title: "产品介绍",
          pageName: "私域知识库AI问答",
        },
        path: "/details/5",
        component: () => import("@/views/home_prod/aiBase.vue"),
      },

      {
        meta: {
          title: "产品介绍",
          pageName: "数字教育",
        },
        path: "/details/6",
        component: () => import("@/views/home_prod/education.vue"),
      },

      // {
      //   meta: {
      //     title: "产品介绍",
      //     pageName: "数字乡村",
      //   },
      //   path: "/details/7",
      //   component: () => import("@/views/home_prod/village.vue"),
      // },

      // {
      //   meta: {
      //     title: "资讯中心",
      //   },
      //   path: "/news",
      //   component: () => import("@/views/home_news.vue"),
      // },
      {
        meta: {
          title: "加入厚笃",
        },
        path: "/recruit",
        component: () => import("@/views/home_recruit.vue"),
      },
      {
        meta: {
          title: "关于我们",
        },
        path: "/about",
        component: () => import("@/views/home_aboutUs.vue"),
      },
    ],
  },
  {
    path: "/",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
